import React, { useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import CheckCircleOutlinedIcon from "@material-ui/icons/CheckCircleOutlined";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import {
  bindingParamsToPath,
  formatPrice,
  getBill,
  paths,
  removeInvoice,
  showBackBtn,
  submitOrder,
} from "../../../actions/actionCreators";
import Skeleton from "@material-ui/lab/Skeleton";
import {
  ASYNC_END,
  CHANGE_ORDER_DESCRIPTION,
  SET_INTERCITY,
} from "../../../actions/actionsTypes";
import { push } from "connected-react-router";
import i18n from "../../../i18nextInitiator";
import ShippingDetails from "../ShippingDetails";
import Invoice from "../Invoice";
import ButtonWithLoading from "../ButtonWithLoading";
import TrackerHoc from "../Tracker/TrackerHoc";
import { compose } from "redux";
import Discount from "./Discount/Discount";
import PriceFeedback from "./PriceFeedback";
import DescriptionInput from "./DescriptionInput";
import ValidPropositions from "./ValidPropositions";
import Divider from "../Divider";
import { store } from "../../../store";

/**
 * Translation function.
 */
const t = i18n.getFixedT("fa", "general");

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 20,
    maxWidth: 600,
    margin: "0 auto",
    "& > *": {
      margin: ".5rem 0",
    },
    "& > *:not(:first-child):not(:last-child)": {
      paddingBottom: 10,
      // borderBottom: "1px solid #a7a7a7"
    },
    paddingBottom: 375,
  },
  box: {
    "& > *": {
      margin: ".15rem 0",
    },
  },
  title: {
    fontSize: "18px",
    fontWeight: 400,
  },
  subtitle: {
    fontWeight: 600,
  },
  price: {
    textAlign: "right",
    fontSize: "20px",
    fontWeight: 900,
  },
  guarantee: {
    color: theme.palette.success.main,
  },
  bottomBoxRoot: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    top: "auto",
    zIndex: "100",
    backgroundColor: "#fff",
    width: "100%",
    maxWidth: 600,
    margin: "0 auto",
    maxHeight: 200,
    boxShadow: "0px 0px 20px 0 rgb(0 0 0 / 20%)",
    borderRadius: "8px 8px 0 0",
  },
  bottomBox: {
    padding: "5px 20px",
    "& > *": {
      margin: ".5rem 0",
    },
    "& > *:not(:first-child):not(:last-child)": {
      paddingBottom: 10,
    },
  },
}));
/**
 * maps redux state to component props.
 * @param state
 */
const mapStateToProps = (state) => ({ ...state });
/**
 * maps dispatch functions to component props.
 * @param dispatch
 */
const mapDispatchToProps = (dispatch) => ({
  getBill,
  submitOrder,
  removeInvoice,
  asyncEnd: () => dispatch({ type: ASYNC_END }),
  track: (id) => {
    dispatch(push(bindingParamsToPath(id, paths.tracking)));
  },
  setIntercity: () => {
    dispatch({ type: SET_INTERCITY });
  },
  changeDescription: (e) => {
    dispatch({ type: CHANGE_ORDER_DESCRIPTION, value: e.target.value });
  },
});
/**
 * Pre Invoice Page
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const PreInvoice = (props) => {
  const { invoice: { bill } = {}, order: { submittingOrder } = {} } =
    props || {};
  let buttonPrice = store.getState().order.order.calc_type;

  const classes = useStyles();
  const [tooltip, setTooltip] = React.useState(false);

  const GridRef = useRef();

  const handleTooltipClose = () => setTooltip(false);
  const handleTooltipOpen = () => setTooltip(true);

  useEffect(() => {
    GridRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
    if (bill && bill.status !== 0) props.track(bill.id);
    showBackBtn();
    return () => props.removeInvoice();
  }, []);

  return (
    <>
      <Grid ref={GridRef} container className={classes.root}>
        <Grid container className={classes.box}>
          <Grid item xs={6}>
            <Typography className={classes.title}>
              {t("invoice.pre.final-price")}{" "}
              {buttonPrice === "cargo_normal_price" && "(عادی)"}
              {buttonPrice === "cargo_special_price" && "(مخصوص)"}
              {buttonPrice === "cargo_vip_price" && "(ویژه)"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            {bill ? (
              <Typography
                className={classes.price}
                style={{ fontSize: bill.price ? "" : "1rem" }}
              >
                {bill.price
                  ? formatPrice(bill.price)
                  : t("invoice.will-call-you-after-submit")}
              </Typography>
            ) : (
              <Skeleton />
            )}
          </Grid>
          <Grid spacing={2} container justifyContent={"space-between"}>
            <Grid item>
              <Typography className={classes.subtitle} variant={"subtitle2"}>
                {t("invoice.pre.price-is-guaranteed-one")}
              </Typography>
              <Typography className={classes.subtitle} variant={"subtitle2"}>
                {t("invoice.pre.price-is-guaranteed-two")}
              </Typography>
              {/* <Typography className={classes.subtitle} variant={"subtitle2"}>
              	{t("invoice.pre.price-is-guaranteed-three")}
              </Typography> */}
            </Grid>
            <Grid item>
              <ClickAwayListener onClickAway={handleTooltipClose}>
                <LightTooltip
                  open={tooltip}
                  title={t("invoice.pre.guarantee-tooltip")}
                >
                  <Typography
                    onMouseEnter={handleTooltipOpen}
                    onMouseLeave={handleTooltipClose}
                    onClick={handleTooltipOpen}
                    className={classes.guarantee}
                    variant={"button"}
                  >
                    <CheckCircleOutlinedIcon fontSize={"small"} />
                    {t("invoice.pre.guarantee-title")}
                  </Typography>
                </LightTooltip>
              </ClickAwayListener>
            </Grid>
          </Grid>

          <PriceFeedback />
          <ValidPropositions />
        </Grid>

        <Invoice preInvoice />

        <DescriptionInput />

        <ShippingDetails />
      </Grid>

      <div className={classes.bottomBoxRoot}>
        <Grid container className={classes.bottomBox}>
          <Discount />
          <ButtonWithLoading
            action={props.submitOrder}
            text={t("invoice.pre.final-submit")}
            loading={submittingOrder}
          />
        </Grid>
      </div>
    </>
  );
};
/**
 * An Styled Component for tooltip
 */
const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    borderColor: theme.palette.success.main,
    fontSize: 14,
    lineHeight: 1.5,
  },
}))(Tooltip);
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  TrackerHoc
)(PreInvoice);
